import { Table, Typography } from '@thinknet-gmbh/platform-common-ui';
import { TableProps } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { formatByMask } from 'src/common/helpers/common.helpers';
import { dateFormat } from 'src/common/helpers/date.helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { ICustomerData } from 'src/pages/customers/customers.interfaces';

import ActionColumnPopover from './action-column-popover.component';

interface IProps extends TableProps<any> {
  data: any;
  openDelete: (record: ICustomerData) => void;
}

const CustomersListTable: FC<IProps> = ({ data, openDelete, pagination, onChange }) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['customers', 'common']);

  return (
    <Table
      t={t}
      dataSource={data}
      rowKey={record => record._id}
      onRow={record => ({
        onClick: () => navigate(`${ROUTES.customers}/${record._id}`),
      })}
      onChange={onChange}
      pagination={pagination}
    >
      <Table.Column
        title={t('customers:labels.companyName')}
        key="companyName"
        dataIndex="companyName"
        sorter
        render={text => <Typography>{text || '-'}</Typography>}
      />
      <Table.Column
        title={t('customers:labels.customerName')}
        key="customerName"
        dataIndex="customerName"
        sorter
        render={text => <Typography>{text || '-'}</Typography>}
      />
      <Table.Column
        title={t('customers:labels.mobilePhoneNumber')}
        key="mobilePhoneNumber"
        dataIndex="mobilePhoneNumber"
        render={text => <Typography>{formatByMask(text, '+## ### ### #######')}</Typography>}
      />
      <Table.Column
        title={t('common:labels.email')}
        dataIndex="email"
        key="email"
        render={text => <Typography>{text || '-'}</Typography>}
      />
      <Table.Column
        title={t('common:labels.creationDate')}
        key="createdAt"
        dataIndex="createdAt"
        render={createdAt => <Typography>{dateFormat(createdAt)}</Typography>}
      />
      <Table.Column
        title={t('common:labels.action')}
        width={50}
        render={record => <ActionColumnPopover record={record} openDelete={openDelete} />}
      />
    </Table>
  );
};

export default CustomersListTable;
